import React from 'react';
import { Phone, Mail, MessageCircle, Github, MapPin, Clock, Aperture, Linkedin, Send, BellRing } from 'lucide-react';
import './ContactUs.css';

const ContactUs = () => {
  const phoneNumber = "+972 50 882 9793";
  const email = "IEZ@cyberservices.com";
  const whatsappNumber = "+972547758567";
  const telegramUsername = "hoodexe";
  const telegramChannel1 = "+4AEO8NTydHYxMDQ0";
  const telegramChannel2 = "+K7S8HGNgPRQ3Nzg8";
  const linkedinProfile = "idan-emanuel-zohar";
  const githubProfile = "IEZ-Security";

  return (
    <div className="matrix-viewport">
      {/* The raining matrix effect background */}
      <div className="matrix-rain-layer"></div>

      <div className="glass-panel">
        {/* Decorative corners */}
        <div className="corner-tag tl"></div>
        <div className="corner-tag tr"></div>
        <div className="corner-tag bl"></div>
        <div className="corner-tag br"></div>

        <div className="header-status">
          <Aperture size={16} className="spin-icon" style={{ color: 'var(--neon)' }} />
          <span className="blink-text" style={{ fontSize: '0.7rem', color: 'rgba(0, 255, 0, 0.5)', letterSpacing: '1px' }}>LINK_ESTABLISHED_SECURE</span>
        </div>

        <h1 className="cyber-title">
          CONTACT_<span>US</span>
        </h1>

        <div className="interaction-list">
          {/* Phone */}
          <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <Phone size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">COMMUNICATION_VOICE</span>
                <span className="info-value" dir="ltr">{phoneNumber}</span>
                <span className="info-description">חייג אלי לשיחה מיידית</span>
              </div>
            </div>
          </a>

          {/* Email */}
          <a href={`mailto:${email}`} className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <Mail size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">COMMUNICATION_MAIL</span>
                <span className="info-value" dir="ltr">{email}</span>
                <span className="info-description">שלח לי הודעת אימייל ואחזור אליך בהקדם</span>
              </div>
            </div>
          </a>

          {/* WhatsApp */}
          <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <MessageCircle size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">INSTANT_MESSAGING</span>
                <span className="info-value">WhatsApp Messages</span>
                <span className="info-description">שלח לי הודעת וואטסאפ לתמיכה מהירה</span>
              </div>
            </div>
          </a>

          {/* Telegram - Private Chat */}
          <a href={`https://t.me/${telegramUsername}`} target="_blank" rel="noopener noreferrer" className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <Send size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">SECURE_COMMS</span>
                <span className="info-value">Telegram - צ'אט פרטי</span>
                <span className="info-description">צור איתי קשר פרטי דרך טלגרם לשאלות אישיות</span>
              </div>
            </div>
          </a>

          {/* Telegram - Main Channel */}
          <a href={`https://t.me/${telegramChannel1}`} target="_blank" rel="noopener noreferrer" className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <BellRing size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">BROADCAST_CHANNEL</span>
                <span className="info-value">Telegram - ערוץ ראשי</span>
                <span className="info-description">הצטרף לערוץ הראשי שלנו לקבלת עדכונים כלליים ומידע חשוב</span>
              </div>
            </div>
          </a>

          {/* Telegram - Green Hood Channel */}
          <a href={`https://t.me/${telegramChannel2}`} target="_blank" rel="noopener noreferrer" className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <BellRing size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">BROADCAST_CHANNEL</span>
                <span className="info-value">Telegram - ערוץ הברדס הירוק</span>
                <span className="info-description">הצטרף לערוץ של הברדס הירוק על מנת לקבל עדכונים בנושא</span>
              </div>
            </div>
          </a>

          {/* LinkedIn */}
          <a href={`https://www.linkedin.com/in/${linkedinProfile}`} target="_blank" rel="noopener noreferrer" className="interactive-row">
            <div className="row-main-content">
              <div className="icon-container">
                <Linkedin size={20} color="#0f0" />
              </div>
              <div className="info-stack">
                <span className="info-label">PROFESSIONAL_NET</span>
                <span className="info-value">IEZ Security</span>
                <span className="info-description">התחברו אליי בלינקדאין</span>
              </div>
            </div>
          </a>


        </div>

        <div className="panel-footer">
          <div className="footer-status">
            <div className="status-item">
              <MapPin size={14} />
              <span>LOCATION: ISRAEL</span>
            </div>
            <div className="status-item">
              <Clock size={14} color="#0f0" />
              <span>STATUS: ימים ב'-ה' | 10:00-19:00</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;